<template>
  <div v-show="showComponent">
    <v-container pa-0 ma-0 fluid>
      <div class="banner-wrap">
        <Banner class="pc-banner " :is-hitech="false" />
      </div>

      <TopBoardCategories
        :header="constants.header"
        :subHeader="constants.subHeader"
        :showSearch="false"
        :class="'articles-lobby'"
      />
      <AncorsNav :navItems="categories" />
    </v-container>
    <v-container pa-0 ma-0 fluid>
      <div class="section_inner">
        <ArticleBreadcrumbs :items="breadCrumbs" class="pr-3" />
        <LobbyPromotions
          class="xs11"
          :articleOfTheWeek="articleOfTheWeek"
          :promotedArticle="promotedArticle"
          :guides="guides"
          :articleOfTheWeekHighlight="constants.articleOfTheWeek"
          :guideTipsHighlight="constants.guides"
        />
        <ArticleTiles
          :title="constants.tools"
          :tools="tools"
        />
        <CategoryArticles
          class="hidden-sm-and-down"
          :items="articlesByCategory"
        />
        <VideoModal />
        <ArticleGuideTips
          class="hidden-md-and-up px-3 mb-12"
          :items="articlesByCategory"
          :logosTitle="
            'test'
          "
        />
      </div>
    </v-container>
    <br />
    <br />
    <br />
  </div>
</template>



<script>
//import { isEmpty } from 'lodash';
import AncorsNav from '@/components/HitechCategories/AncorsNav';
import ArticleGuideTips from '~/components/Articles/ArticleGuideTips';
import ArticleTiles from '@/components/Articles/ArticleTiles';
import Banner from '@/components/Jobs_List/Banner';
import CategoryArticles from '~/components/Articles/CategoryArticles';
import LobbyPromotions from '@/components/Articles/LobbyPromotions';
import SeoOptimization from '@/components/mixins/SeoOptimization';
import TopBoardCategories from '@/components/CategoriesPage/TopBoardCategories';
import { ARTICLES_LOBBY, SEO, axiomLog } from '@/lib/api.js';
import { t } from '@/store/modules/homeDrushim/constantsContent';
import VideoModal from '@/components/VideoModal';

export default {
  mixins: [SeoOptimization],
  name: 'articlesPage',
  components: {
    Banner,
    LobbyPromotions,
    ArticleTiles,
    CategoryArticles,
    ArticleGuideTips,
    AncorsNav,
    TopBoardCategories,
    VideoModal
  },

  data() {
    return {
      showComponent: false,
      articlesByCategory: [],
      categories: [],
      constants: t('titles.articles.lobby'),
      articleOfTheWeek: null,
      promotedArticle: null,
      guides: null,
      tools: null,
      breadCrumbs: []
    };
  },

  async asyncData({ error, route, $axios, $sentry, req }) {
    try {
      // const options = req
      //   ? {
      //       cookie: req.headers.cookie,
      //       'user-agent': req.headers['user-agent'],
      //       'x-rwdr-ip': undefined
      //     }
      //   : {};
      req && delete req.headers['x-rwdr-ip'];
      const {
        data: { data: data }
      } = await $axios.get(`${ARTICLES_LOBBY}`);
      const {
        data: { data: seo }
      } = await $axios.get(`${SEO}/?pageId=29`);

      await axiomLog($axios, route.path, req, error);

      if (data.IsError) {
        throw 'שגיאת מערכת ';
      }

      return {
        showComponent: true,
        categories: data.categories,
        articlesByCategory: data.articlesByCategory,
        articleOfTheWeek: data.articleOfTheWeek,
        promotedArticle: data.promotedArticle,
        guides: data.guides,
        tools: [
          {
            title: 'מחשבון שכר',
            description:
              'באמצעות מחשבון תוכלו לערוך<br>חישוב מדוייק של שכר נטו.',
            link: '/calculator/'
          },
          {
            title: 'טבלאות שכר',
            description: 'טבלאות השכר מעודכנות<br>לינואר 2024.',
            link: '/article/87/'
          },
          {
            title: 'כלי לכתיבת קורות חיים',
            description:
              'כתיבת קו"ח הוא השלב הראשון<br>והחשוב ביותר בחיפוש עבודה.',
            link: '/קורות-חיים/'
          }
        ],
        breadCrumbs: [
          {
            name: 'home',
            value: 'דרושים',
            link: '/'
          },
          {
            name: 'lobby',
            value: 'מגזין קריירה',
            link: '/articles/'
          }
        ],
        seodata: {
          metaData: seo.seoModel.metaDataItems,
          pageTitle: seo.seoModel.title,
          breadCrumbsSchema: {
            '@context': 'https://schema.org',
            '@type': 'BreadcrumbList',
            itemListElement: [
              {
                '@type': 'ListItem',
                position: 1,
                name: 'Home page',
                item: 'https://www.drushim.co.il/'
              },
              {
                '@type': 'ListItem',
                position: 2,
                name: 'Articles lobby'
              }
            ]
          }
        }
      };
    } catch (e) {
      $sentry.captureException('articles lobby error: ' + e);
      try {
        // TBR - test for axiom only
        await $axios.get('https://gw.drushim.co.il/articles/service-info');
        await axiomLog($axios, 'service-info', req, e);
      } catch (e) {
        await axiomLog($axios, 'service-info', req, e);
      }
      await axiomLog($axios, route.path, req, e);
    }
  },

  head() {
    return {
      link: [
        {
          //canonical doesnt returned from api
          rel: 'canonical',
          href: 'https://www.drushim.co.il' + this.$route.fullPath
        }
      ],
      title: this.seodata.pageTitle,
      meta: this.seodata.metaData,
      __dangerouslyDisableSanitizers: ['script'],
      script: [
        {
          innerHTML: JSON.stringify(this.seodata.breadCrumbsSchema),
          type: 'application/ld+json'
        }
      ]
    };
  }
};
</script>
